/**
 * Thermorphous page script
 * - KV slider (Splide fade)
 * - Product slider (Splide loop)
 * - Float contact button toggle & dark-section observer
 */
document.addEventListener('DOMContentLoaded', function () {
	// KVスライダー
	if (document.getElementById('kv-slider')) {
		new Splide('#kv-slider', {
			type: 'fade',
			rewind: true,
			autoplay: true,
			interval: 5000,
			pauseOnHover: false,
			arrows: false,
			pagination: false,
			speed: 5000,
		}).mount();
	}

	// 製品スライダー
	if (document.getElementById('product-slider')) {
		new Splide('#product-slider', {
			type: 'loop',
			rewind: true,
			arrows: true,
			pagination: true,
			speed: 500,
			gap: 0,
		}).mount();
	}

	// フロートボタン展開
	var floatContact = document.getElementById('js-float-contact');
	if (floatContact) {
		var floatBtn = floatContact.querySelector('.thermorphous-float-btn');
		var floatClose = floatContact.querySelector('.thermorphous-float__close');

		floatBtn.addEventListener('click', function (e) {
			e.preventDefault();
			floatContact.classList.add('is-active');
		});

		floatClose.addEventListener('click', function () {
			floatContact.classList.remove('is-active');
		});

		// 閉じるボタンの色を背景に応じて切り替え（Intersection Observer）
		var darkSections = document.querySelectorAll(
			'.thermorphous-kv, .thermorphous-read, .thermorphous-operation, .thermorphous-contact'
		);
		if (darkSections.length > 0) {
			var darkCount = 0;
			// フロートボタンの位置(bottom:36%)に合わせた観測帯
			// 上側48%・下側34%を除外し、ボタン付近の帯のみ監視
			var floatObserver = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						darkCount++;
					} else {
						darkCount = Math.max(0, darkCount - 1);
					}
				});
				if (darkCount > 0) {
					floatContact.classList.add('is-on-dark');
				} else {
					floatContact.classList.remove('is-on-dark');
				}
			}, {
				rootMargin: '-48% 0px -34% 0px',
				threshold: 0
			});

			darkSections.forEach(function (section) {
				floatObserver.observe(section);
			});
		}
	}
});
